import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const fetchProgram = (programId: string, language: string, setProgram: Function, setLoading: Function) => {
  setLoading(true);
  ApiService.get(`programs/${programId}`)
    .then((resp) => setProgram(resp.data.program))
    .catch((error) => {
      console.error("Error loading program:", error);
      alert(translate(language, "PAGES.PROGRAM.ERRORS.LOADING_PROGRAM"));
    })
    .finally(() => setLoading(false));
};
